var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTextMessageStroke = function SvgTextMessageStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5834 18.9167C57.5834 20.1985 57.0742 21.4279 56.1678 22.3343C55.2613 23.2408 54.032 23.75 52.7501 23.75H43.0834L38.2501 31V23.75C36.9682 23.75 35.7388 23.2408 34.8324 22.3343C33.926 21.4279 33.4167 20.1985 33.4167 18.9167V6.83333C33.4167 5.55145 33.926 4.32208 34.8324 3.41565C35.7388 2.50922 36.9682 2 38.2501 2H52.7501C54.032 2 55.2613 2.50922 56.1678 3.41565C57.0742 4.32208 57.5834 5.55145 57.5834 6.83333V18.9167Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3334 9.25H40.6667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3334 16.5H40.6667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 35.833V52.7497C38.25 54.0316 37.7408 55.2609 36.8343 56.1674C35.9279 57.0738 34.6985 57.583 33.4167 57.583H6.83333C5.55145 57.583 4.32208 57.0738 3.41565 56.1674C2.50922 55.2609 2 54.0316 2 52.7497V11.6663C2 10.3845 2.50922 9.15508 3.41565 8.24866C4.32208 7.34223 5.55145 6.83301 6.83333 6.83301H28.5833",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 47.917H2",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1252 51.542C20.2447 51.542 20.3615 51.5774 20.4608 51.6438C20.5602 51.7102 20.6376 51.8046 20.6833 51.915C20.7291 52.0254 20.741 52.1468 20.7177 52.264C20.6944 52.3812 20.6369 52.4889 20.5524 52.5734C20.4679 52.6579 20.3602 52.7154 20.243 52.7387C20.1258 52.762 20.0044 52.7501 19.894 52.7043C19.7836 52.6586 19.6892 52.5812 19.6228 52.4818C19.5564 52.3825 19.521 52.2657 19.521 52.1462C19.521 51.9859 19.5846 51.8323 19.698 51.7189C19.8113 51.6056 19.9649 51.542 20.1252 51.542Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0835 11.667H26.1668",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 41.8747C31.1331 40.3522 27.8633 39.2453 23.7695 37.7301C22.6143 37.2999 22.8028 34.2839 23.3151 33.7209C24.13 32.8383 24.7489 31.7933 25.1312 30.6546C25.5136 29.5159 25.6507 28.3092 25.5336 27.1137C25.6037 26.3687 25.5148 25.6174 25.2729 24.9093C25.031 24.2012 24.6416 23.5525 24.1304 23.0061C23.6191 22.4597 22.9978 22.0281 22.3073 21.7396C21.6169 21.4512 20.8731 21.3126 20.1251 21.333C19.3772 21.3126 18.6334 21.4512 17.9429 21.7396C17.2525 22.0281 16.6311 22.4597 16.1199 23.0061C15.6087 23.5525 15.2193 24.2012 14.9774 24.9093C14.7355 25.6174 14.6466 26.3687 14.7166 27.1137C14.5996 28.3092 14.7367 29.5159 15.119 30.6546C15.5014 31.7933 16.1203 32.8383 16.9351 33.7209C17.4475 34.2839 17.636 37.2999 16.4808 37.7301C12.3918 39.2453 9.11723 40.3522 8.13123 41.8747",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextMessageStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text-message-stroke.e7fc8848.svg";
export { ForwardRef as ReactComponent };